import { Modal, ModalBody, ModalContent } from "@heroui/modal";
import { ReactNode } from 'react';

type BottomSheetProps = {
  isOpen: boolean;
  onClose: () => void;
  children: ReactNode;
};

export const BottomSheet = ({
  isOpen,
  onClose,
  children,
}: BottomSheetProps) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      hideCloseButton
      placement="bottom"
      classNames={{
        wrapper: '!items-end',
        base: '!rounded-none !max-w-full !w-full !m-0 !rounded-t-2xl sm:!mx-0 sm:!my-0',
      }}
    >
      <ModalContent>
        <ModalBody className="p-0">{children}</ModalBody>
      </ModalContent>
    </Modal>
  );
};
